module.exports = __webpack_public_path__ + "img/16_newYouth_mlk.a56d6cd3.png";